import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MobileStoreSettlementBest from "routes/vendor/settlementComp/MobileStoreSettlementBest";
import StoreSettlementAmount from "routes/vendor/settlementComp/StoreSettlementAmount";
import StoreSettlementStatus from "routes/vendor/settlementComp/StoreSettlementStatus";
import StoreSettlementBest from "routes/vendor/settlementComp/StoreSettlementBest";
import styles from "../../vendor/dashboard/VendorNewDashboard.module.css";

function VendotStoreDetail() {
    const location = useLocation();
    const [store, setStore] = useState();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (location.state) {
            setStore(location.state.data);
        }
        setIsLoading(false);
    }, [location]);

    const onStoreDetailClick = () => {
        navigate(`/vendor/storeDetail/${store.id}`, { state: { data: store } });
    };

    if (isLoading) {
        return (
            <div className={styles.container}>
                <div className={styles.flexGrid}>
                    <div className={`${styles.flexBox} ${styles.wideBox}`}>
                        <div className={styles.card}>
                            <div className={styles.section}>
                                <div className={styles.sectionContent}>
                                    <div className={styles.loading}>데이터를 불러오는 중...</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.flexGrid}>
                {/* 헤더 섹션 */}
                <div className={`${styles.flexBox} ${styles.wideBox}`}>
                    <div className={styles.card} style={{ width: "max-content" }}>
                        <div className={styles.section}>
                            <div className={styles.sectionTitle}>
                                <div className={styles.statsHeader}>
                                    <span>{store?.storeName}</span>
                                    {/* <span 
                                        className={styles.moreLink}
                                        onClick={onStoreDetailClick}
                                    >
                                        상세보기
                                    </span> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 정산 금액 섹션 */}
                <div className={`${styles.flexBox} ${styles.wideBox}`}>
                    <div className={styles.section}>
                        <div className={styles.sectionContent} style={{padding: "0"}}>
                            <StoreSettlementAmount storeId={store?.id} />
                        </div>
                    </div>
                </div>

                {/* 베스트 상품 섹션 */}
                <div className={styles.flexBox}>
                    <div className={styles.card}>
                        {/* <div className={styles.section}> */}
                            {/* <div className={styles.sectionTitle}>베스트 상품</div> */}
                            {/* <div className={styles.sectionContent}> */}
                                <StoreSettlementBest
                                    storeId={store?.id}
                                    storeName={store?.storeName}
                                />
                            {/* </div> */}
                        {/* </div> */}
                    </div>
                </div>

                {/* 정산 현황 섹션 */}
                <div className={`${styles.flexBox} ${styles.wideBox}`}>
                    {/* <div className={styles.card}> */}
                        {/* <div className={styles.section}> */}
                            {/* <div className={styles.sectionTitle}>정산 현황</div> */}
                            <div className={styles.sectionContent} style={{padding: 0}}>
                                <StoreSettlementStatus storeId={store?.id} />
                            </div>
                        {/* </div> */}
                    {/* </div> */}
                </div>
            </div>
        </div>
    );
}

export default VendotStoreDetail;